import { useCallback } from 'react';
import ErrorBoundary from 'react-error-boundary';
import PropTypes from 'prop-types';

import { logErrorAndLogToServer } from 'middleware/logger';

const MartyErrorBoundary = ({ boundaryTag, children }) => {
  // useCallback w/ react-hooks so we don't pass a brand new function every time this re-renders
  const FallbackComponent = useCallback(() => <div style={{ display: 'none' }} data-component-boundary-error={`Error while rendering the component ${boundaryTag ? `([${boundaryTag}])` : ''}`}/>, [boundaryTag]);
  const onError = useCallback(() => error => {
    const errorMessage = `An error has occurred while rendering component contained with MartyErrorBoundary: ${error.toString()}`;
    logErrorAndLogToServer(`${boundaryTag ? `[${ boundaryTag}]: ` : ''}${errorMessage}`);
  }, [boundaryTag]);

  return <ErrorBoundary FallbackComponent={FallbackComponent} onError={onError}>{children}</ErrorBoundary>;
};

MartyErrorBoundary.propTypes = {
  boundaryTag: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired
};

export const withErrorBoundary = (boundaryTag, Component) => {
  const WrappedComponent = props => <MartyErrorBoundary boundaryTag={boundaryTag}><Component {...props}/></MartyErrorBoundary>;
  WrappedComponent.displayName = `${getDisplayName(Component)}ErrorBoundary`;
  return WrappedComponent;
};
// helper for HOC
function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

export default MartyErrorBoundary;
